import React, { useState, useEffect } from 'react';
import Navbar from './NavBar';
import Sidebar from './Sidebar';
import { useNavigate, useLocation } from 'react-router-dom';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
  logoSrc: string;
  appName: string;
  onLogout: () => void;
}

const Layout: React.FC<LayoutProps> = ({ children, logoSrc, appName, onLogout }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleMenuClick = (menu: string) => {
    switch (menu) {
      case 'Calendario':
        navigate('/');
        break;
      case 'Articulos':
        navigate('/articulos');
        break;
      case 'Historias':
        navigate('/historias');
        break;
      case 'Admin':
        navigate('/admin');
        break;
      case 'Configuracion':
        navigate('/configuracion');
        break;
      default:
        break;
    }
    // Close mobile menu after navigation
    if (isMobile) {
      setIsMobileMenuOpen(false);
    }
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const getActiveMenu = () => {
    const path = location.pathname;
    if (path === '/') return 'Calendario';
    if (path === '/articulos') return 'Articulos';
    if (path === '/historias') return 'Historias';
    if (path === '/configuracion') return 'Configuracion';
    if (path === '/admin') return 'Admin';
    return '';
  };

  return (
    <div className="home-container">
      <Navbar
        logoSrc={logoSrc}
        appName={appName}
        onLogout={onLogout}
        isMobile={isMobile}
        onToggleMobileMenu={toggleMobileMenu}
      />
      <div className="app-content">
        <Sidebar
          onMenuClick={handleMenuClick}
          activeMenu={getActiveMenu()}
          isMobile={isMobile}
          isMobileMenuOpen={isMobileMenuOpen}
          onCloseMobileMenu={() => setIsMobileMenuOpen(false)}
          onLogout={onLogout}
        />
        <main className="main-content">
          {children}
        </main>
      </div>
      {isMobileMenuOpen && <div className="mobile-backdrop" onClick={() => setIsMobileMenuOpen(false)} />}
    </div>
  );
};

export default Layout; 